(function () {
  "use strict";

  angular
    .module("trainerWebApp.directives")
    .directive("mfEditGroupTrainersSidebar", mfEditGroupTrainersSidebar);

  function mfEditGroupTrainersSidebar() {
    return {
      restrict: "A",
      link: function ($scope, elem, attrs) {
        var select = $("#inputTrainersMultiple");

        var opts = $scope.selectTrainersOptions;

        opts.formatResult = function (object, container, query) {

          var term = $.trim(query.term || "");
          var html = '<div title="' + object.name + '" >';

          if (object.label && !object.hideLabelInDropDown)
            html = html + '<span>' + object.label + ': </span>';
          var startOfCriteriaInResult = _.escape(object.name).toLowerCase().indexOf(term.toLowerCase());


          if (startOfCriteriaInResult > 0)
            html = html + '<span>' + object.name.substr(0, startOfCriteriaInResult) + '</span>';
          else
            startOfCriteriaInResult = 0;

          html = html + '<span class="select2-match">' + object.name.substr(startOfCriteriaInResult, term.length) + '</span>';
          if (object.name.length > startOfCriteriaInResult + term.length) {
            var startOfRestOfResult = startOfCriteriaInResult + term.length;
            html = html + '<span>' + _.escape(object.name).substr(startOfRestOfResult, object.name.length - startOfRestOfResult) + '</span>';
          }

          html = html + '</div>';
          container[0].innerHTML = html;
        };

        select.select2(opts);

        select.on("select2-selecting", function (event) {
          $scope.$apply(function () {
            $scope.addTrainer(event.object);
          });
          clearInput();
          event.preventDefault();
        });

        function clearInput() {
          var searchInput = elem.find('.select2-input');
          select.select2('close');
          searchInput.val('');
          searchInput.removeClass("select2-default");
        }

        select.on("select2-open", function (event) {
          $('.select2-dropdown-size-hack').removeClass('select2-dropdown-size-hack');
        });

        $scope.forceCloseDropDown = function () {
          select.select2('close');
        };

        $scope.$on('$destroy', function () {
          $scope.forceCloseDropDown();
        });
      }
    }
  }

})();
